import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import Timestamp from "components/Timestamp";

import { FileTreeNode } from "../../../fileTreeHelpers";

const UpdatedAtCell = ({ item, ...cellProps }: TableSimpleCellProps<FileTreeNode>) => {
  return (
    <TableSimpleCell {...cellProps}>
      {item.file?.revision.createdAt ? (
        <Timestamp timestamp={item.file.revision.createdAt} />
      ) : (
        <TableCellEmpty />
      )}
    </TableSimpleCell>
  );
};

export default UpdatedAtCell;
